export const initialAbility = [
    {
        action: 'read',
        subject: 'Auth',
    },
    {
        action: 'visit',
        subject: 'auth-reset-password'
    },
    {
        action: 'read',
        subject: 'auth-login'
    },
    {
        action: 'read',
        subject: 'select-organization'
    },
];

export const _ = undefined
